module.exports = __webpack_public_path__ + "static/favicon-d17303a9d35558139f85d71a66ad8e1b.ico";